import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Portal from 'react-portal';
import FullScreenOverlay from '../FullScreenOverlay.js';
import uuidV4 from 'uuid/v4';


class RulePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }

        this.addRule = this.addRule.bind(this);

    }

    addRule(rule) {
        rule.key = rule.key.replace('Rule','');
        rule.id = uuidV4();
        this.props.addRule(rule);
    }

    render() {
        return <Portal closeOnEsc onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
            <FullScreenOverlay>
                <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                    <h1>New rule</h1>
                    <h2>Select the rule you want to add</h2>

                    <div className="m-t-30 col-sm-8 offset-sm-2">
                        <ul className="list-group list-group-full">
                            {
                                Object.keys(this.props.available).map(key => {
                                    for(let i in this.props.rules) {
                                        if('Rule'+this.props.rules[i].key == key) {
                                            return null;
                                        }
                                    }
                                    const Comp = this.props.available[key];
                                   return <Comp key={key} addRule={this.addRule} ruleKey={key} onlyDescription={true} />;
                                })
                            }
                        </ul>
                    </div>


                </div>
            </FullScreenOverlay>
        </Portal>
    }
}

export default RulePicker;


// WEBPACK FOOTER //
// ./components/builder/RulePicker.js